import { useChallenges } from '../../../redux/reducer/content';

export default function useGetUserAchievementsWithMaxGrade() {
  const { icons } = useChallenges();

  return (iconsList = icons) => {
    const filteredAchievements = [];

    function recurseSearch(iconsList) {
      iconsList.forEach((achievement) => {
        const { needed_premium, hasIcon, child } = achievement;
        if (!needed_premium && hasIcon && child?.every?.(({ hasIcon } = {}) => !hasIcon))
          filteredAchievements.push(achievement);
        else if (!!child?.length) recurseSearch(achievement.child);
      });
    }

    recurseSearch(iconsList);

    return filteredAchievements;
  };
}
